export const showPaasSaasSwitch = [
  'demo.facets.cloud',
  'facetsdemo.console.facets.cloud',
  'root.console.facets.cloud',
  'localhost:4300',
].includes(window.location.host);

export const PRODUCT_FRUIT_TOUR_GUIDE_ID = 69121;
